import { useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import InputText from '../../../components/Inputs/Text';
import Button from '../../../components/Button';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const SignUp = ({ onSwitch }) => {
    const { signup } = useAuth();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const passwordRules = [
        { test: (p) => p.length >= 8,          label: 'Mínimo 8 caracteres' },
        { test: (p) => /[A-Z]/.test(p),         label: '1 letra maiúscula' },
        { test: (p) => /[a-z]/.test(p),         label: '1 letra minúscula' },
        { test: (p) => /[0-9]/.test(p),         label: '1 número' },
        { test: (p) => /[^A-Za-z0-9]/.test(p), label: '1 caractere especial' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('As senhas não coincidem.');
            return;
        }

        const failedRule = passwordRules.find(r => !r.test(password));
        if (failedRule) {
            setError(`A senha precisa ter: ${failedRule.label}.`);
            return;
        }

        setLoading(true);

        const result = await signup({ name, email, password });

        if (!result) {
            setError('Não foi possível criar a conta. Tente novamente.');
        }

        setLoading(false);
    };

    const isFormValid = name && email && password && confirmPassword
        && passwordRules.every(r => r.test(password))
        && password === confirmPassword;

    return (
        <div className="auth-form">
            <h2>Criar conta</h2>

            <form onSubmit={handleSubmit} className="auth-form-fields">
                <InputText
                    label="Nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <InputText
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <InputText
                    label="Senha"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!error}
                    suffix={
                        <IconButton size="small" onClick={() => setShowPassword(v => !v)} edge="end">
                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                    }
                />

                {password && (
                    <ul className="auth-password-rules">
                        {passwordRules.map((rule) => (
                            <li key={rule.label} className={rule.test(password) ? 'valid' : 'invalid'}>
                                {rule.test(password) ? '✓' : '✗'} {rule.label}
                            </li>
                        ))}
                    </ul>
                )}
                <InputText
                    label="Confirmar senha"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={!!error}
                    helperText={error}
                    suffix={
                        <IconButton size="small" onClick={() => setShowConfirmPassword(v => !v)} edge="end">
                            {showConfirmPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                    }
                />

                {error && <p className="auth-error">{error}</p>}

                <Button
                    label="Criar conta"
                    kind="primary"
                    loading={loading}
                    disabled={!isFormValid}
                    onClick={handleSubmit}
                />
            </form>

            <p className="auth-switch">
                Já tem uma conta?{' '}
                <span onClick={onSwitch}>Entrar</span>
            </p>
        </div>
    );
};

export default SignUp;
